













































































































































































































import moment from 'moment'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import FileApi from "../../../components/File/logic/file-api";
import { atSignedLogin, tgLoginLink } from '../../../shared/utils/tgLoginHelpers'
import Icon from '../../Icon/Icon.vue'
import { CashRegisterType } from "../CashRegisters/types";
import { Notice, NoticeState } from './types'

const MOMENT_FORMAT = 'LL HH:mm:ss'

@Component({
  data() {
    return {
      CashRegisterType,
      NoticeState
    }
  },
  methods: {
    atSignedLogin
  },
  components: {
    Icon
  }
})
export default class NoticeCard extends Vue {
  @Prop() notice!: Notice

  @Emit()
  refundPayment() {
    return this.notice
  }

  fileApi = new FileApi()

  get beautifiedDate() {
    return moment(this.notice.date).format(MOMENT_FORMAT)
  }

  get beautifiedPaymentDate() {
    if (this.notice.payment) {
      return moment(this.notice.payment?.date).format(MOMENT_FORMAT)
    }

    return ''
  }

  productName(name: Notice['details'][0]['product']['name']) {
    if (name.length > 20) {
      return `${ name.slice(0, 10) }...${ name.slice(-10) }`
    } else {
      return name
    }
  }

  productDescription(description: Notice['details'][0]['product']['description']) {
    if (description.length > 200) {
      return description.slice(0, 197) + '...'
    } else {
      return description
    }
  }

  sendMessageToUser(): void {
    window.open(tgLoginLink(this.notice.customer.login))
  }
}
